import { useMutation } from '@apollo/client';
import { AttachmentItemHolder } from '@nile/banyan/src/Components/Editors/RTEditor';
import {
  AccessControl,
  AppContext,
  AttachmentPreviewer,
  BackgroundIcon,
  DateTimeFormatter,
  generateString,
  Icon,
  getDownloadURL,
  ALL_MODULES,
  getTranslatedText
} from '@nile/components';
import { SPLIT_TICKET } from '@nile/graphql/src';
import envConfig from '@nile/home/src/Config/env';
import SplitSheet from '@nile/mangifera/src/Components/Sheets/SplitSheet';
import Recepients from '@nile/mangifera/src/Components/Chat/Recepients';
import EmailFailureStatus from './EmailFailureState';
import { Receiver, Sender } from '@nile/mangifera/src/Pebbles/chat';
import { Popover, Link, Avatar, TextStyle } from '@superops/ui-design-system';
import { DotsVertical } from '@styled-icons/boxicons-regular';
import dompurify from 'dompurify';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import Collapse from 'react-collapse';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';
import { Tooltip } from 'react-clone-tippy';
import OriginalMessage from '@nile/mangifera/src/Components/Sheets/OriginalMessage';
import { SVGIcon } from '@superops/super-icons';
import {
  dompurifier,
  getFormattedDateTime
} from '@nile/components/src/Utils/helpers';

const StyledNote = styled.div`
  background: ${(props) =>
    props.user ? '#e5fdff;' : 'var(--sops-coversation-bubble-bg)'};
  border-radius: 20px 20px;
  width: 80%;
  padding: 10px 15px 15px 15px;
  opacity: 1;
  transition: opacity 200ms linear;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.102874);
  .message-content {
    margin-top: 10px;
    word-break: break-word;
  }
  .action > div:first-child {
    visibility: hidden;
  }
  .more-icon {
    height: 14px;
    width: 24px;
    padding: 4px;
    border-radius: 4px;
    background-color: var(--sops-ticket-coversation-more-icon-bg);
    cursor: pointer;
    margin-top: 4px;
    opacity: 0.6;
  }
  .notification {
    background-color: #f2f2f7;
    border-radius: 10px;
    padding: 10px;
  }

  &:hover {
    .action > div:first-child {
      visibility: visible;
      cursor: pointer;
    }
  }
  .ReactCollapse--collapse {
    transition: height 150ms linear;
  }
  .ap {
    background-image: url(${envConfig.imageRoot}emojis.webp);
  }
  .time {
    max-width: 35%;
  }
  .hover-hand {
    cursor: zoom-in;
  }
  .mw100 {
    max-width: 100%;
  }

  /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 10; /* Sit on top */
    // padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
  }

  /* Modal Content (image) */
  .modal-content {
    margin: auto;
    display: block;
    // width: 100%;
    max-width: 90vw;
  }

  @-webkit-keyframes zoom {
    from {
      -webkit-transform: scale(0);
    }
    to {
      -webkit-transform: scale(1);
    }
  }

  @keyframes zoom {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }

  /* The Close Button */
  .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

  /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px) {
    .modal-content {
      width: 100%;
    }
  }

  .sender-name {
    display: inline-flex;
    max-width: 180px;
  }
`;

export const ItemHolders = styled.div`
  div {
    &:first-child {
      margin-left: 0;
    }
  }
`;

const SenderToolTip = ({ name }) => {
  const TooltipStyles = styled.div`
    background: white;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.21);
    border-radius: 4px;
    height: 30px;
    padding: 0 5px;
    min-width: fit-content;
    width: 100%;
    display: flex;
    max-width: fit-content;
    align-items: center;
  `;
  return (
    <TooltipStyles>
      <TextStyle variation="strong">{name}</TextStyle>
    </TooltipStyles>
  );
};

export const AttachmentsContainer = styled(AttachmentItemHolder)`
  padding: 0 1rem;
  margin-left: 8px;
  &:hover {
    cursor: default;
  }
`;

function ConversationBubble(props) {
  const { message, intl } = props;
  const appContext = useContext(AppContext);
  const { user, company } = appContext;
  const [popoverActive, setPopoverActive] = useState(false);
  const [ticketSubject, setTicketSubject] = useState('');
  const [copyFields, setCopyFields] = useState([]);
  const [randomId, setRandomId] = useState(generateString(5) || 'abcde');
  const [isOpen, setIsOpen] = useState(false);
  const [attachmentsList, setAttachments] = useState([]);
  const [showAttachmentPreview, setShowAttachmentPreview] = useState({
    show: false,
    index: 0
  });
  const toggleIsOpen = useCallback(() => {
    setIsOpen(!isOpen);
  });
  // useEffect(() => {
  //   console.log('mounting');
  //   return () => {
  //     console.log('unmounting');
  //   };
  // }, []);

  const getAttachmentURL = (message, item) => {
    const module = ALL_MODULES.ticketConversationAttachment;
    const details = {
      fileName: item?.fileName,
      conversationId: message?.id,
      ticketId: message?.ticketId
    };
    const url = getDownloadURL({ module, details });
    return url;
  };

  useEffect(() => {
    let attachments = [];
    if (message && message.attachments && message.attachments.length)
      attachments = message.attachments.map((item) => {
        return {
          name: item?.fileName,
          type: item?.fileName?.substr(
            item?.fileName.lastIndexOf('.') + 1,
            item?.fileName.length
          ),
          url: getAttachmentURL(message, item)
        };
      });
    setAttachments(attachments);
  }, [message.attachments]);

  const [splitTickets] = useMutation(SPLIT_TICKET, {
    onCompleted(res) {
      console.log(res);
    },
    onError(res) {
      console.log(res);
    }
  });

  const togglePopoverActive = useCallback(() => {
    setPopoverActive((popoverActive) => !popoverActive);
    setTicketSubject('');
  });

  const handleEscPress = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (e?.keyCode === 27 || e?.which === 27 || e?.key === 'Escape') {
      if (
        window.getComputedStyle(document.querySelector(`.modal-inline-images`))
          .display === 'flex'
      ) {
        document.querySelector(`.modal-inline-images`).style.display = 'none';
      }
      window.removeEventListener('keyup', handleEscPress);
    }
  };

  const imageDownloader = (e) => {
    // window.open(e.target.currentSrc, '_blank').focus();
    const modal = document.querySelector(`.modal-inline-images`);

    const modalImg = document.querySelector(`.modal-content-inline-images`);

    modal.style.display = 'flex';
    modalImg.src = e.target.currentSrc;
    window.addEventListener('keyup', handleEscPress);
  };

  useEffect(() => {
    if (
      document.querySelector(`.${randomId}`)?.querySelectorAll('img')?.length
    ) {
      document
        ?.querySelector(`.${randomId}`)
        ?.querySelectorAll('img')
        ?.forEach((img) => {
          img.classList.add('hover-hand', 'mw100');
          img.addEventListener('click', imageDownloader);
        });
      return () => {
        document
          ?.querySelector(`.${randomId}`)
          ?.querySelectorAll('img')
          ?.forEach((img) => {
            img.classList.remove('hover-hand');
            img.removeEventListener('click', imageDownloader);
          });
      };
    }
  }, []);

  const activator = (
    <div onClick={togglePopoverActive} className="ptr">
      <SVGIcon name="Menu" size="sm" />
    </div>
  );

  const splitTicket = (subject, copyFields) => {
    splitTickets({
      variables: {
        ticketId: message.ticketId,
        conversationId: message.id,
        subject,
        copyFields
      }
    }).then((res) => {
      message.callback && message.callback(res);
    });
  };

  const Tags = {
    sender: Sender,
    receiver: Receiver
  };
  const userType =
    message.user?.userId === user?.userId ? 'sender' : 'receiver';
  const Tag = Tags[userType];

  /**
   * @description
   * Closing attachment previewer
   */
  const closePreviwer = () => {
    setShowAttachmentPreview({
      ...showAttachmentPreview,
      show: false
    });
  };

  /**
   * @description
   * opening attachment previewer, if selected from a specific index then opening from the selected index.
   * @param {object} attachment
   * @param {number} index
   */

  function openAttachmentPreview(index) {
    setShowAttachmentPreview({
      ...showAttachmentPreview,
      show: true,
      index
    });
  }

  const getUserName = (message) => {
    if (message?.user?.firstName) {
      return `${message.user.firstName} ${message.user?.lastName || ''}`;
    } else if (message?.user?.email) {
      return message.user.email;
    }
    return getTranslatedText(intl, 'ticket.details.note.system');
  };

  const getUserInitials = (message) => {
    if (message?.user?.firstName) {
      return `${message.user.firstName?.[0]} ${message.user?.lastName?.[0] ||
        ''}`;
    } else if (message?.user?.email) {
      return message.user.email?.[0];
    }
    return getTranslatedText(intl, 'ticket.details.note.system')?.[0];
  };

  const getConversationIcon = (type) => {
    switch (type) {
      case 'DESCRIPTION':
        return 'Reply';
      case 'VENDOR_REPLY':
        return 'helpcenter';
      default:
        return 'onboardingNotificationTemplate';
    }
  };

  const htmlString = dompurifier(message.message, {
    FORBID_TAGS: ['style']
  });

  const htmlToDisplay = htmlString.replaceAll('<img', "<img loading='lazy'");

  return (
    <Tag className="fx bubbleContainer" id="bubble-cont">
      <div className="avatar">
        <Avatar
          size="small"
          initials={getUserInitials(message)}
          source={
            message.authorId === 'system' &&
            message.messageType !== 'DESCRIPTION'
              ? `${envConfig.imageRoot}svg/notification.svg`
              : ''
          }
        />
      </div>
      <SwitchTransition>
        <CSSTransition
          key={message.id}
          timeout={200}
          in
          appear
          classNames="bubbles"
          unmountOnExit
        >
          <StyledNote
            className="bubble"
            user={message.user && userType === 'sender'}
          >
            <div className="fx">
              <div className="fx2 fx actr f-12">
                {!message.user && (
                  <div className="mr8 fx actr">
                    <SVGIcon
                      name={getConversationIcon(message.messageType)}
                      size="sm"
                    />
                  </div>
                )}
                {message.user || message.messageType === 'DESCRIPTION' ? (
                  <div className="flex center">
                    <TextStyle variation="subdued f-12">
                      {message.messageType === 'DESCRIPTION' ? (
                        <span>
                          <FormattedMessage id="ticket.details.postedBy" />
                          &nbsp;
                        </span>
                      ) : (
                        <FormattedMessage id="ticket.details.chat.reply" />
                      )}
                      {/* do not remove */}
                      {'  '}
                      <Tooltip
                        html={<SenderToolTip name={getUserName(message)} />}
                        delay={100}
                        duration={250}
                        position="bottom-start"
                        inertia
                        trigger="mouseenter"
                        animation="shift"
                        animateFill={false}
                        allowHTML
                        theme="super-light"
                      >
                        <TextStyle variation="strong">
                          <span className="sender-name pointer">
                            <span className="ellipsis">
                              {getUserName(message)}
                            </span>
                          </span>
                        </TextStyle>
                      </Tooltip>
                    </TextStyle>
                    <div className="ml8">
                      <Tooltip
                        html={<Recepients message={message} />}
                        delay={300}
                        duration={250}
                        position="bottom-start"
                        inertia
                        trigger="mouseenter"
                        animation="shift"
                        animateFill={false}
                        theme="super-light"
                      >
                        <div className="flex center">
                          <SVGIcon name="DropSheet" size="sm" />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                ) : (
                  <>
                    <TextStyle variation="subdued f-12">
                      <TextStyle>
                        <FormattedMessage id="ticket.details.emailNotificationSent.label" />
                      </TextStyle>
                    </TextStyle>
                    {!message.user ? (
                      <div onClick={toggleIsOpen} className="ml8 more-icon">
                        <BackgroundIcon
                          height="6px"
                          width="16px"
                          url={`url(${envConfig.imageRoot}svg/more.svg)`}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </>
                )}
              </div>

              <div
                className="time fx jend f-12"
                title={getFormattedDateTime(
                  message?.time,
                  company?.dateFormat || 'DD MMM YYYY',
                  company?.timeFormat || 'hh:mm A'
                )}
                // title={dayjs(message.time).format(
                //   `${company?.dateFormat ||
                //     'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                // )}
              >
                <TextStyle variation="subdued">
                  <DateTimeFormatter type="dateTime" date={message?.time} />

                  {/* {dayjs(message.time).format(
                    `${company?.dateFormat ||
                      'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                  )} */}
                </TextStyle>
              </div>
              <EmailFailureStatus
                toUsers={message?.toUsers}
                ccUsers={message?.ccUsers}
                bccUsers={message?.bccUsers}
              />
              {message.user || message.messageType === 'DESCRIPTION' ? (
                <AccessControl
                  roleToCheck="splitTicket.allow"
                  render={
                    <div className="flex action center pl5">
                      <Popover
                        active={popoverActive}
                        activator={activator}
                        onClose={() => {
                          togglePopoverActive();
                        }}
                      >
                        <SplitSheet splitTicket={splitTicket} />
                        <OriginalMessage message={message} />
                      </Popover>
                    </div>
                  }
                  fallback={
                    <div className="flex action center pl5">
                      <Popover
                        active={popoverActive}
                        activator={activator}
                        onClose={() => {
                          togglePopoverActive();
                        }}
                      >
                        <OriginalMessage message={message} fullHeight />
                      </Popover>
                    </div>
                  }
                />
              ) : (
                ''
              )}
            </div>
            <Collapse
              isOpened={
                message.user || message.messageType === 'DESCRIPTION' || isOpen
              }
            >
              <p
                id="html-message-content"
                className={`${
                  !message.user && message.messageType !== 'DESCRIPTION'
                    ? 'notification'
                    : ''
                } message-content ${randomId}`}
                dangerouslySetInnerHTML={{
                  __html: htmlToDisplay
                }}
              />
              <ItemHolders className="mt-10">
                {message?.attachments?.map((item, index) => {
                  return (
                    <AttachmentsContainer>
                      <Link
                        onClick={() => openAttachmentPreview(index)}
                        removeUnderline
                      >
                        {item?.originalFileName}
                      </Link>
                    </AttachmentsContainer>
                  );
                })}
              </ItemHolders>
            </Collapse>
          </StyledNote>
        </CSSTransition>
      </SwitchTransition>
      {showAttachmentPreview.show && (
        <AttachmentPreviewer
          showPreviewer={showAttachmentPreview.show}
          closePreviwer={closePreviwer}
          list={attachmentsList}
          selectedIndex={showAttachmentPreview.index}
        />
      )}
    </Tag>
  );
}

export default injectIntl(ConversationBubble);
